import { createReducer } from "reduxsauce";
import ReducerRegister from "../../ReducerRegister";
import AsyncActionReducers from "../../AsyncActionReducers";
import { ActionTypes } from "../../actionTypes/screens/bbs/MyActivityActionTypes";
import { ActionTypes as DefaultActionTypes } from "../../actionTypes/screens/bbs/DefaultActionTypes";
import { ActionTypes as SearchActionTypes } from "../../actionTypes/screens/bbs/SearchActionTypes";
import { ActionTypes as DetailsActionTypes } from "../../actionTypes/screens/bbs/DetailsActionTypes";
import MyActivityService from "../../../services/screens/bbs/MyActivityService";
import DetailsService from "../../../services/screens/bbs/DetailsService";
import UIDs from "../../../UIDs";
import _ from "lodash";

function filterDuplicatedPost(list) {
    var keys = new Map();
    var result = [];
    list.forEach((it, index) => {
        if (!keys.has(it.id)) {
            keys.set(it.id, index);
            result.push(it);
        }
    });
    return result;
}

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            MyActivityService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (vo, data) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        vo,
        data,
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error,
    }),

    refreshScreenAsync: () => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.REFRESH_SCREEN_ASYNC });

            const vo = {};
            MyActivityService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.refreshScreenSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.refreshScreenFailure(error));
                }
            );
        };
    },

    refreshScreenSuccess: (vo, data) => ({
        type: ActionTypes.REFRESH_SCREEN_SUCCESS,
        parentType: ActionTypes.REFRESH_SCREEN_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        vo,
        data,
    }),

    refreshScreenFailure: error => ({
        type: ActionTypes.REFRESH_SCREEN_FAILURE,
        parentType: ActionTypes.REFRESH_SCREEN_ASYNC,
        postReducer: updateScreenInBackgroundFailurePostReducer,
        error,
    }),

    loadMorePostAsync: vo => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.LOAD_MORE_POST_ASYNC });

            MyActivityService.loadMorePost(
                vo,
                response => {
                    dispatch(Actions.loadMorePostSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.loadMorePostFailure(error));
                }
            );
        };
    },

    loadMorePostSuccess: (vo, data) => ({
        type: ActionTypes.LOAD_MORE_POST_SUCCESS,
        parentType: ActionTypes.LOAD_MORE_POST_ASYNC,
        postReducer: loadMorePostSuccessPostReducer,
        vo,
        data,
    }),

    loadMorePostFailure: error => ({
        type: ActionTypes.LOAD_MORE_POST_FAILURE,
        parentType: ActionTypes.LOAD_MORE_POST_ASYNC,
        postReducer: updateScreenInBackgroundFailurePostReducer,
        error,
    }),

    loadMoreReplyAsync: vo => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.LOAD_MORE_REPLY_ASYNC });

            MyActivityService.loadMoreReply(
                vo,
                response => {
                    dispatch(Actions.loadMoreReplySuccess(vo, response));
                },
                error => {
                    dispatch(Actions.loadMoreReplyFailure(error));
                }
            );
        };
    },

    loadMoreReplySuccess: (vo, data) => ({
        type: ActionTypes.LOAD_MORE_REPLY_SUCCESS,
        parentType: ActionTypes.LOAD_MORE_REPLY_ASYNC,
        postReducer: loadMoreReplySuccessPostReducer,
        vo,
        data,
    }),

    loadMoreReplyFailure: error => ({
        type: ActionTypes.LOAD_MORE_REPLY_FAILURE,
        parentType: ActionTypes.LOAD_MORE_REPLY_ASYNC,
        postReducer: updateScreenInBackgroundFailurePostReducer,
        error,
    }),

    loadMoreFavouriteAsync: vo => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.LOAD_MORE_FAVOURITE_ASYNC });

            MyActivityService.loadMoreFavourite(
                vo,
                response => {
                    dispatch(Actions.loadMoreFavouriteSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.loadMoreFavouriteFailure(error));
                }
            );
        };
    },

    loadMoreFavouriteSuccess: (vo, data) => ({
        type: ActionTypes.LOAD_MORE_FAVOURITE_SUCCESS,
        parentType: ActionTypes.LOAD_MORE_FAVOURITE_ASYNC,
        postReducer: loadMoreFavouriteSuccessPostReducer,
        vo,
        data,
    }),

    loadMoreFavouriteFailure: error => ({
        type: ActionTypes.LOAD_MORE_FAVOURITE_FAILURE,
        parentType: ActionTypes.LOAD_MORE_FAVOURITE_ASYNC,
        postReducer: updateScreenInBackgroundFailurePostReducer,
        error,
    }),

    changeActiveTab: val => ({
        type: ActionTypes.CHANGE_ACTIVE_TAB,
        val,
    }),

    addLikeAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.ADD_LIKE_ASYNC });

            DetailsService.addLike(
                vo,
                response => {
                    dispatch(Actions.addLikeSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.addLikeFailure(error));
                }
            );
        };
    },

    addLikeSuccess: (vo, data) => ({
        type: ActionTypes.ADD_LIKE_SUCCESS,
        parentType: ActionTypes.ADD_LIKE_ASYNC,
        postReducer: addLikeSuccessPostReducer,
        vo,
        data,
    }),

    addLikeFailure: error => ({
        type: ActionTypes.ADD_LIKE_FAILURE,
        parentType: ActionTypes.ADD_LIKE_ASYNC,
        error,
    }),

    removeLikeAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REMOVE_LIKE_ASYNC });

            DetailsService.removeLike(
                vo,
                response => {
                    dispatch(Actions.removeLikeSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.removeLikeFailure(error));
                }
            );
        };
    },

    removeLikeSuccess: (vo, data) => ({
        type: ActionTypes.REMOVE_LIKE_SUCCESS,
        parentType: ActionTypes.REMOVE_LIKE_ASYNC,
        postReducer: removeLikeSuccessPostReducer,
        vo,
        data,
    }),

    removeLikeFailure: error => ({
        type: ActionTypes.REMOVE_LIKE_FAILURE,
        parentType: ActionTypes.REMOVE_LIKE_ASYNC,
        error,
    }),

    addFavouriteAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.ADD_FAVOURITE_ASYNC });

            DetailsService.addFavourite(
                vo,
                response => {
                    dispatch(Actions.addFavouriteSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.addFavouriteFailure(error));
                }
            );
        };
    },

    addFavouriteSuccess: (vo, data) => ({
        type: ActionTypes.ADD_FAVOURITE_SUCCESS,
        parentType: ActionTypes.ADD_FAVOURITE_ASYNC,
        postReducer: addFavouriteSuccessPostReducer,
        vo,
        data,
    }),

    addFavouriteFailure: error => ({
        type: ActionTypes.ADD_FAVOURITE_FAILURE,
        parentType: ActionTypes.ADD_FAVOURITE_ASYNC,
        error,
    }),

    removeFavouriteAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REMOVE_FAVOURITE_ASYNC });

            DetailsService.removeFavourite(
                vo,
                response => {
                    dispatch(Actions.removeFavouriteSuccess(vo, response));
                },
                error => {
                    dispatch(Actions.removeFavouriteFailure(error));
                }
            );
        };
    },

    removeFavouriteSuccess: (vo, data) => ({
        type: ActionTypes.REMOVE_FAVOURITE_SUCCESS,
        parentType: ActionTypes.REMOVE_FAVOURITE_ASYNC,
        postReducer: removeFavouriteSuccessPostReducer,
        vo,
        data,
    }),

    removeFavouriteFailure: error => ({
        type: ActionTypes.REMOVE_FAVOURITE_FAILURE,
        parentType: ActionTypes.REMOVE_FAVOURITE_ASYNC,
        error,
    }),

    addReplyAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.ADD_REPLY_ASYNC });

            DetailsService.addReply(
                vo,
                response => {
                    dispatch(Actions.addReplySuccess(vo, response));
                },
                error => {
                    dispatch(Actions.addReplyFailure(error));
                }
            );
        };
    },

    addReplySuccess: (vo, data) => ({
        type: ActionTypes.ADD_REPLY_SUCCESS,
        parentType: ActionTypes.ADD_REPLY_ASYNC,
        postReducer: addReplySuccessPostReducer,
        vo,
        data,
    }),

    addReplyFailure: error => ({
        type: ActionTypes.ADD_REPLY_FAILURE,
        parentType: ActionTypes.ADD_REPLY_ASYNC,
        error,
    }),

    removeReplyAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REMOVE_REPLY_ASYNC });

            DetailsService.deleteReply(
                vo,
                response => {
                    dispatch(Actions.removeReplySuccess(vo, response));
                },
                error => {
                    dispatch(Actions.removeReplyFailure(error));
                }
            );
        };
    },

    removeReplySuccess: (vo, data) => ({
        type: ActionTypes.REMOVE_REPLY_SUCCESS,
        parentType: ActionTypes.REMOVE_REPLY_ASYNC,
        postReducer: removeReplySuccessPostReducer,
        vo,
        data,
    }),

    removeReplyFailure: error => ({
        type: ActionTypes.REMOVE_REPLY_FAILURE,
        parentType: ActionTypes.REMOVE_REPLY_ASYNC,
        error,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    postList: [],
    replyList: [],
    favouriteList: [],
    activeTab: 1,
    postCount: 0,
    replyCount: 0,
    favouriteCount: 0,
    postListParams: {
        pageSize: 10,
        pageIndex: 1,
        hasMore: false,
    },
    replyListParams: {
        pageSize: 10,
        pageIndex: 1,
        hasMore: false,
    },
    favouriteListParams: {
        pageSize: 10,
        pageIndex: 1,
        hasMore: false,
    },
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { vo, data }) => {
    let postList = _.clone(data.postList.postList);
    let postListParams = _.clone(state.postListParams);
    postListParams.pageIndex = 1;
    postListParams.hasMore = data.postList.totalCount > postList.length;

    let replyList = _.clone(data.replyList.postList);
    let replyListParams = _.clone(state.replyListParams);
    replyListParams.pageIndex = 1;
    replyListParams.hasMore = data.replyList.totalCount > replyList.length;

    let favouriteList = _.clone(data.favouriteList.postList);
    let favouriteListParams = _.clone(state.favouriteListParams);
    favouriteListParams.pageIndex = 1;
    favouriteListParams.hasMore = data.favouriteList.totalCount > favouriteList.length;

    return { ...state, postCount: data.postCount,
             replyCount: data.replyCount,
             favouriteCount: data.favouriteCount,
             replyList, replyListParams, favouriteList, favouriteListParams };
};

const loadMorePostSuccessPostReducer = (state, { vo, data }) => {
    let postList = _.clone(state.postList);
    postList = postList.concat(data.postList);

    let postListParams = _.clone(state.postListParams);
    postListParams.pageIndex = vo.pageIndex;
    postListParams.hasMore = data.totalCount > postList.length;

    return { ...state, postList, postListParams };
};

const loadMoreReplySuccessPostReducer = (state, { vo, data }) => {
    let replyList = _.clone(state.replyList);
    replyList = replyList.concat(data.postList);

    let replyListParams = _.clone(state.replyListParams);
    replyListParams.pageIndex = vo.pageIndex;
    replyListParams.hasMore = data.totalCount > replyList.length;

    return { ...state, replyList, replyListParams };
};

const loadMoreFavouriteSuccessPostReducer = (state, { vo, data }) => {
    let favouriteList = _.clone(state.favouriteList);
    favouriteList = favouriteList.concat(data.postList);

    let favouriteListParams = _.clone(state.favouriteListParams);
    favouriteListParams.pageIndex = vo.pageIndex;
    favouriteListParams.hasMore = data.totalCount > favouriteList.length;

    return { ...state, favouriteList, favouriteListParams };
};

const updateScreenInBackgroundFailurePostReducer = (state, { error }) => {
    return { ...state, needUpdateInBackground: false };
};

const changeActiveTabReducer = (state, { val }) => {
    return { ...state, activeTab: val };
};

const addLikeSuccessPostReducer = (state, { vo, data }) => {
    if (vo.replyId) {
        return { ...state };
    }

    const favouriteList = _.clone(state.favouriteList);
    let i = _.findIndex(favouriteList, s => s.id === vo.postId);
    if (i >= 0) {
        let item = _.clone(favouriteList[i]);
        item.isMyLike = true;
        item.likeCount = data.likeCount;
        favouriteList[i] = item;
    }
    return { ...state, favouriteList };
};

const removeLikeSuccessPostReducer = (state, { vo, data }) => {
    if (vo.replyId) {
        return { ...state };
    }

    const favouriteList = _.clone(state.favouriteList);
    let i = _.findIndex(favouriteList, s => s.id === vo.postId);
    if (i >= 0) {
        let item = _.clone(favouriteList[i]);
        item.isMyLike = false;
        item.likeCount = data.likeCount;
        favouriteList[i] = item;
    }
    return { ...state, favouriteList };
};

const addFavouriteSuccessPostReducer = (state, { vo, data }) => {
    return { ...state };
};

const removeFavouriteSuccessPostReducer = (state, { vo, data }) => {
    let favouriteCount = state.favouriteCount;
    const favouriteList = _.clone(state.favouriteList);
    let i = _.findIndex(favouriteList, s => s.id === vo.postId);
    if (i >= 0) {
        favouriteList.splice(i, 1);
        favouriteCount -= 1;
    }
    return { ...state, favouriteList, favouriteCount };
};

const addReplySuccessPostReducer = (state, { vo, data }) => {
    return { ...state };
};

const removeReplySuccessPostReducer = (state, { vo, data }) => {
    let replyCount = state.replyCount;
    const replyList = _.clone(state.replyList);
    let i = _.findIndex(replyList, s => s.id === vo.postId);
    if (i >= 0) {
        const item = _.cloneDeep(replyList[i]);
        let j = _.findIndex(item.replyList, s => s.id === vo.replyId);
        if (j >= 0) {
            item.replyList.splice(j, 1);
            replyCount -= 1;
        }

        if (item.replyList.length > 0) {
            replyList[i] = item;
        } else {
            replyList.splice(i, 1);
        }
    }
    return { ...state, replyList, replyCount };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REFRESH_SCREEN_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REFRESH_SCREEN_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REFRESH_SCREEN_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_MORE_POST_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_MORE_POST_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_MORE_POST_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_MORE_REPLY_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_MORE_REPLY_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_MORE_REPLY_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_MORE_FAVOURITE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_MORE_FAVOURITE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_MORE_FAVOURITE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CHANGE_ACTIVE_TAB]: changeActiveTabReducer,
    [ActionTypes.ADD_LIKE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.ADD_LIKE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.ADD_LIKE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REMOVE_LIKE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REMOVE_LIKE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REMOVE_LIKE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.ADD_FAVOURITE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.ADD_FAVOURITE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.ADD_FAVOURITE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REMOVE_FAVOURITE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REMOVE_FAVOURITE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REMOVE_FAVOURITE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.ADD_REPLY_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.ADD_REPLY_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.ADD_REPLY_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REMOVE_REPLY_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REMOVE_REPLY_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REMOVE_REPLY_FAILURE]: AsyncActionReducers.failureReducer,
    [DefaultActionTypes.ADD_LIKE_SUCCESS]: addLikeSuccessPostReducer,
    [DefaultActionTypes.REMOVE_LIKE_SUCCESS]: removeLikeSuccessPostReducer,
    [SearchActionTypes.ADD_LIKE_SUCCESS]: addLikeSuccessPostReducer,
    [SearchActionTypes.REMOVE_LIKE_SUCCESS]: removeLikeSuccessPostReducer,
    [DetailsActionTypes.ADD_LIKE_SUCCESS]: addLikeSuccessPostReducer,
    [DetailsActionTypes.REMOVE_LIKE_SUCCESS]: removeLikeSuccessPostReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.bbs.myactivity, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
